// extracted by mini-css-extract-plugin
export default {"canvas":"canvas-VebT1W"};